// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/global.css
// module id = vCD6
// module chunks = 1